<template>
  <div class="main-body">
    <div class="notice-preview">
      <div class="ql-snow">
        <div class="ql-editor" v-html="content">
        </div>
      </div>
    </div>

    <el-upload
      class="avatar-uploader"
      :action="articleImgUrl"
      name="img"
      :headers="headerObj"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :before-upload="beforeUpload">
    </el-upload>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import { doGetNotice, } from '@/utils/server'

  export default {
    name: "index",
    data() {
      return {
        content: ''
      }
    },
    methods: {
      getNotice() {
        this.loading = true;
        doGetNotice({}).then(response => {
          if (response.data) {
            this.noticeEnable = response.data.noticeEnable === '1';
            this.content = response.data.noticeContent;
          }
          this.loading = false;
          console.log(response)
        });
      },
    },
    mounted() {
      this.getNotice();
    }
  }
</script>

<style scoped>
  .main-body {
    width: 950px;
    margin: 0 auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/notice/index.vue